import { TRootState } from '../index';

export const ErrorState = (state: TRootState) => state.common.error;
